var video = '';
var youtubeUrl = '';
var nextYoutubeUrl = '';
var canPlayModal = true;
var observer = '';

(function ($) {

  $('.btn-modal a, .btn-modal button').hover(function () {
    canPlayModal = false;
  }, function () {
    canPlayModal = true;
  });

  $(document).keyup(function (e) {
    var $modal = $('.modal');
    if (e.key === "Escape" && $modal.hasClass('modal--open')) {
      if (video) video.pause();

      $modal.removeClass('modal--open');
      $modal.css('display', 'none');
    }
  });

  $(document).on('click', '.btn-modal', function (e) {
    e.preventDefault();
    const $this = $(this);

    const isBtnChildFocus = $this.find('button, a').is(':focus');

    if (!canPlayModal || isBtnChildFocus) return;

    const modalId = $this.data('modal-id'),
      $modal = $('#' + modalId),
      $close = $modal.find('.modal__close'),
      $videoContainer = $modal.find('.video-container');

    var dataIndex = $this.data('index');

    if (youtubeUrl !== $this.data('youtube-url')) {
      createVideo($this.data('youtube-url'));
    }

    $modal.css('display', 'block'); // Display the modal when the button is clicked

    if (video) {
      setCookie('vodcast_index_' + window.postId, dataIndex);
      video.play();
    }

    setTimeout(function () {
      // Add class for the animation
      $modal.addClass('modal--open');
    }, 50);

    // Close modal when the close button is clicked
    $close.on('click', function () {
      closeModalVideo();
    });

    // Close modal when clicking outside the modal content
    window.addEventListener('click', function (event) {
      if (event.target === $modal.get(0)) {
        closeModalVideo();
      }
    });

    if (video) {
      video.addEventListener('ended', onVideoEnded);
    }

    function closeModalVideo() {
      if (video) video.pause();

      $modal.removeClass('modal--open');
      $modal.css('display', 'none');
    }

    function createVideo(url) {
      video = document.createElement('youtube-video');
      youtubeUrl = url;
      video.setAttribute('src', url);
      video.setAttribute('width', 640);
      video.setAttribute('height', 360);
      video.setAttribute('autoplay', true);
      video.setAttribute('controls', true);
      video.setAttribute('webkit-playsinline', true);
      video.setAttribute('playsinline', true);

      // replace child container
      $videoContainer.html(video);
    }

    function onVideoEnded() {
      var $nextVodcast = $('.btn-vodcast-play[data-index="' + dataIndex + '"]').next(),
        nextIndex = $nextVodcast.data('index'),
        nextUrl = $nextVodcast.data('youtube-url');
      dataIndex = nextIndex;

      if (!$nextVodcast.length) return;

      createVideo(nextUrl);
      setCookie('vodcast_index_' + window.postId, nextIndex);
      video.play();

      video.addEventListener('ended', onVideoEnded);
    }
  });
})(jQuery);

function setCookie(cookieName, cookieValue) {
  const expirationDate = new Date();

  // Set the expiration date to one year from now
  expirationDate.setFullYear(expirationDate.getFullYear() + 15);

  // Create the cookie string
  const cookieString = cookieName + '=' + encodeURIComponent(cookieValue) +
    '; expires=' + expirationDate.toUTCString() +
    '; path=/; Secure;';

  // Set the cookie
  document.cookie = cookieString;
}
